const METHODS = {
    setInitialContractTypes: 'setInitialContractTypes',
    setCurrentQuality: 'setCurrentQuality',
    setCurrentCoverage: 'setCurrentCoverage',
    setCurrentCoverageSum: 'setCurrentCoverageSum',
    setCurrentCoverageAmount: 'setCurrentCoverageAmount',
    setCurrentStartDate: 'setCurrentStartDate',
    setCurrentEndDate: 'setCurrentEndDate',
    setCurrentDurationValue: 'setCurrentDurationValue',
    setCurrentTimeUnit: 'setCurrentTimeUnit',
    setCurrentContractType: 'setCurrentContractType',
    setCurrentPricing: 'setCurrentPricing',
    setDurationWordings: 'setDurationWordings',
    setHideDurationSelection: 'setHideDurationSelection',
    setDurationDropdownHeadline: 'setDurationDropdownHeadline',
    setBundlePrice: 'setBundlePrice',
};

export default METHODS;
